import localforage from 'localforage'

const auditStore = localforage.createInstance({
  name: 'erp-pos',
  storeName: 'pos',
})

const AUDIT_KEY = 'pos_audit_events'
const MAX_EVENTS = 500

export type PosAuditEvent =
  | 'created'
  | 'persisted'
  | 'push_started'
  | 'push_confirmed'
  | 'push_failed'
  | 'printed'
  | 'dismissed'
  | 'reconcile_attempt'

export type PosAuditEntry = {
  client_uuid: string
  event: PosAuditEvent
  at: string
  meta?: Record<string, unknown>
}

export async function logPosAuditEvent(
  clientUuid: string,
  event: PosAuditEvent,
  meta?: Record<string, unknown>,
): Promise<void> {
  if (!clientUuid) return
  const entry: PosAuditEntry = {
    client_uuid: clientUuid,
    event,
    at: new Date().toISOString(),
    meta,
  }
  const raw = (await auditStore.getItem<PosAuditEntry[]>(AUDIT_KEY)) ?? []
  const next = [...raw, entry].slice(-MAX_EVENTS)
  await auditStore.setItem(AUDIT_KEY, next)
}

export async function getPosAuditEvents(clientUuid?: string): Promise<PosAuditEntry[]> {
  const raw = (await auditStore.getItem<PosAuditEntry[]>(AUDIT_KEY)) ?? []
  if (!clientUuid) return raw
  return raw.filter((e) => e.client_uuid === clientUuid)
}

export async function getPosAuditTrailForClient(clientUuid: string): Promise<PosAuditEntry[]> {
  return getPosAuditEvents(clientUuid)
}
